__turbopack_context__.v({
  "detailsSection": "TeamContactInfoEdit-module-scss-module__Az8tPG__detailsSection",
});
